import { ArrowLeftOutlined, UserOutlined } from '@ant-design/icons';
import { useIntl, useModel } from '@umijs/max';
import { Button } from 'antd';
import React from 'react';
import styles from './index.less';

const ActingAsMerchantBanner: React.FC = () => {
  const intl = useIntl();
  const { actingAsMerchantOwner, exitMerchantOwnerMode } =
    useModel('actingAsMerchant');

  if (!actingAsMerchantOwner) return null;

  const displayName =
    actingAsMerchantOwner.displayName || actingAsMerchantOwner.username;

  return (
    <div className={styles.banner}>
      <div className={styles.info}>
        <UserOutlined />
        <span>
          {intl.formatMessage(
            {
              id: 'component.actingAsMerchantOwner.label',
              defaultMessage: 'Acting as: {name}',
            },
            { name: displayName },
          )}
        </span>
      </div>
      <Button
        className={styles.exitBtn}
        size="small"
        ghost
        icon={<ArrowLeftOutlined />}
        onClick={exitMerchantOwnerMode}
      >
        {intl.formatMessage({
          id: 'component.actingAsMerchantOwner.exit',
          defaultMessage: 'Back to Admin',
        })}
      </Button>
    </div>
  );
};

export default ActingAsMerchantBanner;
